import { render, staticRenderFns } from "./SupplierPayments.vue?vue&type=template&id=25a3c06e&scoped=true"
import script from "./SupplierPayments.vue?vue&type=script&lang=js"
export * from "./SupplierPayments.vue?vue&type=script&lang=js"
import style0 from "./SupplierPayments.vue?vue&type=style&index=0&id=25a3c06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3c06e",
  null
  
)

export default component.exports